import { defineMessage } from 'services/localization';

export const messages = {
    header: defineMessage('please_note_that_amount__another_batch_payments'),
    amountOnApproval: defineMessage('bulletamount_on_approval'),
    amountAwaitingPayment: defineMessage('bulletamount_is_approved_and_awaiting_payment'),
    amountInProcessing: defineMessage('bulletamount_in_processing'),
    amountOnReview: defineMessage('bulletamount_on_review'),
};
